function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.9998 7.12657C11.8016 7.12657 13.2623 5.66589 13.2623 3.86406C13.2623 2.06223 11.8016 0.601562 9.9998 0.601562C8.19798 0.601562 6.7373 2.06223 6.7373 3.86406C6.7373 5.66589 8.19798 7.12657 9.9998 7.12657Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6001 7.125C17.7392 7.125 18.6626 6.20159 18.6626 5.0625C18.6626 3.92341 17.7392 3 16.6001 3C15.461 3 14.5376 3.92341 14.5376 5.0625C14.5376 6.20159 15.461 7.125 16.6001 7.125Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.3999 7.125C4.53899 7.125 5.4624 6.20159 5.4624 5.0625C5.4624 3.92341 4.53899 3 3.3999 3C2.26082 3 1.3374 3.92341 1.3374 5.0625C1.3374 6.20159 2.26082 7.125 3.3999 7.125Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.43203 8.97942C4.62015 8.31425 3.88489 8.4023 2.94615 8.4023C1.54215 8.4023 0.399902 9.53779 0.399902 10.9332V15.0285C0.399902 15.6345 0.894527 16.1273 1.50278 16.1273C4.12875 16.1273 3.8124 16.1748 3.8124 16.014C3.8124 13.1121 3.46868 10.9839 5.43203 8.97942Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8927 8.41534C9.25304 8.27858 7.82785 8.41692 6.59857 9.43159C4.54143 11.0793 4.93732 13.298 4.93732 16.0121C4.93732 16.7302 5.52157 17.3253 6.25057 17.3253C14.1661 17.3253 14.4812 17.5807 14.9506 16.5412C15.1045 16.1897 15.0623 16.3014 15.0623 12.9386C15.0623 10.2676 12.7496 8.41534 10.8927 8.41534Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0537 8.4022C16.1099 8.4022 15.3787 8.31505 14.5679 8.97933C16.5166 10.9689 16.1875 12.9519 16.1875 16.0139C16.1875 16.1757 15.9249 16.1272 18.4577 16.1272C19.0877 16.1272 19.6 15.6168 19.6 14.9894V10.9331C19.6 9.5377 18.4577 8.4022 17.0537 8.4022Z",
  fill: "white"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.e3fe1c64.svg";
export { ForwardRef as ReactComponent };